import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdEmail, MdArrowBack } from 'react-icons/md';
import styles from './Login.module.css';
import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';
// import ConfirmationModal from '../components/ConfirmationModal/ConfirmationModal';


const Login = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [resendTimer, setResendTimer] = useState(0);

    const [confirmModal, setConfirmModal] = useState({
        show: false,
        title: '',
        message: '',
        type: 'info',
        onConfirm: null
    });

    const handleSendOTP = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await fetch('https://lulliconazole.onrender.com/api/auth/send-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email_address: email })
            });

            const data = await response.json();
            console.log(data);
            if (response.ok && data.success) {
                setStep(2);
                startResendTimer();
                setConfirmModal({
                    show: true,
                    title: 'OTP Sent!',
                    message: 'Verification code has been sent to your email address. Please check your inbox.',
                    type: 'success',
                    onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
                });
            } else {
                setError(data.message || 'Failed to send OTP. Please try again.');
            }
        } catch (err) {
            setError('Network error. Please check if backend is running on port 5000.');
        } finally {
            setLoading(false);
        }
    };

    const handleOtpChange = (index, value) => {
        if (value && !/^\d$/.test(value)) return;
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`)?.focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            document.getElementById(`otp-${index - 1}`)?.focus();
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6);
        if (!/^\d+$/.test(pastedData)) return;
        const newOtp = pastedData.split('').concat(Array(6).fill('')).slice(0, 6);
        setOtp(newOtp);
        const lastIndex = Math.min(pastedData.length, 5);
        document.getElementById(`otp-${lastIndex}`)?.focus();
    };

    // const handleVerifyOTP = async (e) => {
    //     e.preventDefault();
    //     const otpCode = otp.join('');

    //     if (otpCode.length !== 6) {
    //         setError('Please enter complete 6-digit code');
    //         return;
    //     }

    //     setError('');
    //     setLoading(true);

    //     try {
    //         const response = await fetch('https://lulliconazole.onrender.com/api/auth/verify-otp', {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify({ email_address: email, otp: otpCode })
    //         });

    //         const data = await response.json();

    //         if (response.ok && data.success) {
    //             localStorage.setItem('token', data.token);
    //             localStorage.setItem('user', JSON.stringify(data.user));

    //             setConfirmModal({
    //                 show: true,
    //                 title: 'Login Successful!',
    //                 message: 'Welcome back! Redirecting to dashboard...',
    //                 type: 'success',
    //                 onConfirm: () => {
    //                     setConfirmModal({ ...confirmModal, show: false });
    //                     navigate('/', { replace: true });
    //                 }
    //             });
    //         } else {
    //             setError(data.message || 'Invalid verification code. Please try again.');
    //             setOtp(['', '', '', '', '', '']);
    //             document.getElementById('otp-0')?.focus();
    //         }
    //     } catch (err) {
    //         setError('Network error. Please try again.');
    //         setOtp(['', '', '', '', '', '']);
    //         document.getElementById('otp-0')?.focus();
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleVerifyOTP = async (e) => {
        e.preventDefault();
        const otpCode = otp.join('');

        if (otpCode.length !== 6) {
            setError('Please enter complete 6-digit code');
            return;
        }

        setError('');
        setLoading(true);

        try {
            const response = await fetch('https://lulliconazole.onrender.com/api/auth/verify-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email_address: email, otp: otpCode })
            });

            const data = await response.json();

            if (response.ok && data.success) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
                navigate('/', { replace: true });
            } else {
                setError(data.message || 'Invalid verification code. Please try again.');
                setOtp(['', '', '', '', '', '']);
                document.getElementById('otp-0')?.focus();
            }
        } catch (err) {
            setError('Network error. Please try again.');
            setOtp(['', '', '', '', '', '']);
            document.getElementById('otp-0')?.focus();
        } finally {
            setLoading(false);
        }
    };
    const handleResendOTP = async () => {
        if (resendTimer > 0) return;

        setError('');
        setLoading(true);

        try {
            const response = await fetch('https://lulliconazole.onrender.com/api/auth/resend-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email_address: email })
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setOtp(['', '', '', '', '', '']);
                document.getElementById('otp-0')?.focus();
                startResendTimer();
                setConfirmModal({
                    show: true,
                    title: 'OTP Resent!',
                    message: 'A new verification code has been sent to your email.',
                    type: 'success',
                    onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
                });
            } else {
                setError(data.message || 'Failed to resend OTP. Please try again.');
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const startResendTimer = () => {
        setResendTimer(60);
        const interval = setInterval(() => {
            setResendTimer(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const handleBackToEmail = () => {
        setStep(1);
        setOtp(['', '', '', '', '', '']);
        setError('');
    };

    return (
        <div className={styles.loginPage}>
            <div className={styles.loginContainer}>
                <div className={styles.loginCard}>
                    <div className={styles.logoSection}>
                        <div className={styles.logo}>SclinEDC</div>
                        <h1 className={styles.title}>QBS-Lulliconazole Study</h1>
                        <p className={styles.subtitle}>Version: 1.0</p>
                    </div>

                    {step === 1 ? (
                        <>
                            <h2 className={styles.formTitle}>Sign In</h2>
                            <p className={styles.formSubtitle}>Enter your email address to receive verification code</p>

                            <form onSubmit={handleSendOTP} className={styles.form}>
                                <div className={styles.inputGroup}>
                                    <label>Email Address</label>
                                    <div className={styles.inputWrapper}>
                                        <MdEmail className={styles.inputIcon} />
                                        <input
                                            type="email"
                                            placeholder="Enter your email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            disabled={loading}
                                            autoFocus
                                        />
                                    </div>
                                </div>

                                {error && <div className={styles.error}>{error}</div>}

                                <button type="submit" className={styles.submitBtn} disabled={loading}>
                                    {loading ? 'Sending...' : 'Send Verification Code'}
                                </button>
                            </form>
                        </>
                    ) : (
                        <>
                            <button className={styles.backButton} onClick={handleBackToEmail} disabled={loading}>
                                <MdArrowBack /> Back
                            </button>

                            <h2 className={styles.formTitle}>Verify Email</h2>
                            <p className={styles.formSubtitle}>
                                Enter the 6-digit code sent to<br />
                                <strong>{email}</strong>
                            </p>

                            <form onSubmit={handleVerifyOTP} className={styles.form}>
                                <div className={styles.otpContainer}>
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            id={`otp-${index}`}
                                            type="text"
                                            maxLength="1"
                                            className={styles.otpInput}
                                            value={digit}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                            onPaste={index === 0 ? handleOtpPaste : undefined}
                                            autoFocus={index === 0}
                                            disabled={loading}
                                        />
                                    ))}
                                </div>

                                {error && <div className={styles.error}>{error}</div>}

                                <button
                                    type="submit"
                                    className={styles.submitBtn}
                                    disabled={loading || otp.join('').length !== 6}
                                >
                                    {loading ? 'Verifying...' : 'Verify & Sign In'}
                                </button>

                                <div className={styles.resendSection}>
                                    {resendTimer > 0 ? (
                                        <p className={styles.resendTimer}>Resend code in {resendTimer}s</p>
                                    ) : (
                                        <p className={styles.resendText}>
                                            Didn't receive code?
                                            <button
                                                type="button"
                                                onClick={handleResendOTP}
                                                className={styles.resendBtn}
                                                disabled={loading}
                                            >
                                                Resend
                                            </button>
                                        </p>
                                    )}
                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>

            <ConfirmationModal
                show={confirmModal.show}
                title={confirmModal.title}
                message={confirmModal.message}
                type={confirmModal.type}
                onConfirm={confirmModal.onConfirm}
            // onCancel={() => setConfirmModal({ ...confirmModal, show: false })}
            />
        </div>
    );
};

export default Login;